import React, { useState } from "react";
import { Question, Rating } from "../types";
import { FaStar } from "react-icons/fa";
import { deleteSurveyQuestion, writeRandomNumbersToRatingResults } from "../Firebase/utils";
import { deleteQuestion } from "../store/features/CreateSurveySlice";
import { useAppDispatch, useAppSelector } from "../store/store";
import RatingForm from "./RatingForm";
import QuestionPreviewContainer from "./QuestionPreviewContainer";
import useDeleteSurveyQuestion from "../CustomHooks/useDeleteSureveyQuestion";

interface RatingPreviewDisplayProps {
    question: Question;
    questionText: string;
    questionBody: Rating;
}

export default (props: RatingPreviewDisplayProps) => {

    const { question, questionText, questionBody } = props;
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const [ modalOpen, setModalOpen ] = useState<boolean>(false);
    
    const { deleteQuestion, loading, error } = useDeleteSurveyQuestion(survey, question);

    const handleEditQuestion = () => {
        writeRandomNumbersToRatingResults(survey.id, question);
        setModalOpen(true);
        // try{
        //     updateSurveyQuestion(user, survey, question);
        //     dispatch(updateQuestion(question));
        // }catch(err){
        //     console.error(err);
        // }        
    }

    const generateStars = () => {
        const stars = [];
        for (let i = 0; i < questionBody.max; i++) {
            stars.push(<FaStar className="text-[#3da8e2] md:text-3xl"/>);
        }
        return stars;
    };

    return (
        <QuestionPreviewContainer question={question} handleDeleteQuestion={() => deleteQuestion()} handleEditQuestion={handleEditQuestion}>
            <div className="flex flex-col gap-4">
                <div className="flex gap-5">
                    <p>Min: {questionBody.min}</p>
                </div>
                <div className="flex gap-5">
                    <p>Max: {questionBody.max}</p>
                </div>
                <div className="flex">
                    {generateStars()}
                </div>
            </div>
            <RatingForm openState={modalOpen} onClose={() => { setModalOpen(false) }} question={question}/>
        </QuestionPreviewContainer>
    )
}